
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gnOKIAug0WKt0XZHbLhLrT7_45FSzxzUEHdCETrCWQ3haAMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index_45DhxnKUKPhrZrqQ9P2J3iYrS0Blia_451hJATo_45zoVYiEMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchznqk9Ae33LDhK8A_iu7Xaqv2_ZXtluHirsTiUiLCtsAMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexC4MCdVV2fwsAt_45UJkcB8kVvcGMnTIDlZiEXeJEK0IFsMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_930WqqMI5xVP4ss_2r_45TpgpjyL8HWimgt_OVi_45_459vK8acMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexZKy5Vz2_45Z5D1d7IDc_45R_rjEAdjTEHv0T0DQ_45GgYEPgEMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93WGsAAGTC1COK1FWwssOlLy9xFR46zkFyxwV14NdXDPkMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexXpg0qLDFx4GAaiqSQm5R5tFrIoJjzwyWnn_45xbrYs7P4Meta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93gr0dSLxrUffeKXl1_45vVMoQEOD7MZr2VN28P3RtnDHlYMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexRRzSD2ax1aGnAVp4HxKzit8Fouw6BcQppB37tq2jyAIMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexYe26OeQGVSutHpF_45MaHLX9TA_450dIMKGZg8cjz0XyqAkMeta } from "/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexZKy5Vz2_45Z5D1d7IDc_45R_rjEAdjTEHv0T0DQ_45GgYEPgEMeta || {},
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexXpg0qLDFx4GAaiqSQm5R5tFrIoJjzwyWnn_45xbrYs7P4Meta || {},
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexRRzSD2ax1aGnAVp4HxKzit8Fouw6BcQppB37tq2jyAIMeta || {},
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexYe26OeQGVSutHpF_45MaHLX9TA_450dIMKGZg8cjz0XyqAkMeta || {},
    component: () => import("/codebuild/output/src3294310329/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]